'use client';

import { c as _c } from "react/compiler-runtime";
import { UrlStateProvider } from '@feat/feat-url-state/provider';
import type { UrlState } from '@feat/feat-url-state/schema';
import type { DehydratedState } from '@tanstack/react-query';
import { HydrationBoundary } from '@tanstack/react-query';
import dynamic from 'next/dynamic';
import { MapProvider } from 'react-map-gl/maplibre';
import { MapPageLoadingShell } from './map-page-loading-shell';
const MapContainer = dynamic(() => import('@feat/feat-map/container').then(mod => ({
  default: mod.MapContainer
})), {
  ssr: false,
  loading: () => <MapPageLoadingShell />
});
type MapPageClientProps = {
  initialState: UrlState;
  dehydratedState: DehydratedState;
};
export function MapPageClient(t0) {
  const $ = _c(6);
  const {
    initialState,
    dehydratedState
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MapProvider><MapContainer /></MapProvider>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== dehydratedState) {
    t2 = <HydrationBoundary state={dehydratedState}>{t1}</HydrationBoundary>;
    $[1] = dehydratedState;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== initialState || $[4] !== t2) {
    t3 = <UrlStateProvider defaultValue={initialState} initialUrlSync={true}>{t2}</UrlStateProvider>;
    $[3] = initialState;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}